/* eslint-disable no-unused-expressions */
// Drupal behavior that controls the display all link on species directory.
(function speciesDirecotryScript($, Drupal) {
  Drupal.behaviors.speciesDirecotry = {
    attach(context) {
      function selectIndex($id, $key) {
        document.getElementById($id).selectedIndex = $key;
      }

      function getIndex($id) {
        const index = document.getElementById($id).selectedIndex;
        return index;
      }

      $('#display_all_link').click(function cc() {
        document.getElementById('items_per_page').selectedIndex = '3';
        $('#species_directory').submit();
      });

      // Sort by Species Name and show corresponding arrow based selected index.
      $('#hc_species_name').click(function sort() {
        if (getIndex('filter_sort') === 5) {
          selectIndex('filter_sort', 0);
        }
        else {
          selectIndex('filter_sort', 5);
        }
        $('#species_directory').submit();
      });
      if (getIndex('filter_sort') === 5) {
        $('#hc_species_name .fa-sort-down').show();
        $('#hc_species_name .fa-sort').remove();
      }

      // Sort by Species Category and show corresponding arrow based selected index.
      $('#hc_species_category').click(function sort() {
        if (getIndex('filter_sort') === 1) {
          selectIndex('filter_sort', 2);
        }
        else {
          selectIndex('filter_sort', 1);
        }
        $('#species_directory').submit();
      });
      if (getIndex('filter_sort') === 1) {
        $('#hc_species_category .fa-sort-up').show();
        $('#hc_species_category .fa-sort').hide();
      }
      if (getIndex('filter_sort') === 2) {
        $('#hc_species_category .fa-sort-down').show();
        $('#hc_species_category .fa-sort').hide();
      }

      // Sort by Species Region and show corresponding arrow based selected index.
      $('#hc_region').click(function sort() {
        if (getIndex('filter_sort') === 3) {
          selectIndex('filter_sort', 4);
        }
        else {
          selectIndex('filter_sort', 3);
        }
        $('#species_directory').submit();
      });
      if (getIndex('filter_sort') === 3) {
        $('#hc_region .fa-sort-up').show();
        $('#hc_region .fa-sort').hide();
      }
      if (getIndex('filter_sort') === 4) {
        $('#hc_region .fa-sort-down').show();
        $('#hc_region .fa-sort').hide();
      }
    },
  };
}(jQuery, Drupal));
